import { render, staticRenderFns } from "./classesModal.vue?vue&type=template&id=f028f432&"
import script from "./classesModal.vue?vue&type=script&lang=js&"
export * from "./classesModal.vue?vue&type=script&lang=js&"
import style0 from "./classesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports